import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";
import {  useTheme } from '@material-ui/core';
import { createGradient } from "../../utils/themeColors";

const useStyles = makeStyles((theme) => ({
    modernTitle: {
        fontSize: "1.25rem",
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
    },
    modernFilters: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        flexWrap: "wrap",
    },
    modernButton: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: theme.spacing(1, 2),
    },
    chartContainer: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
    }
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: false,
        },
        datalabels: {
            display: true,
            anchor: 'end',
            align: "end",
            color: "#333",
            font: {
                size: 12,
                weight: "600"
            },
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            grid: {
                color: 'rgba(0, 0, 0, 0.05)',
            },
            ticks: {
                font: {
                    size: 11,
                }
            }
        },
        x: {
            grid: {
                display: false,
            },
            ticks: {
                font: {
                    size: 11,
                }
            }
        }
    },
};

export const ChartsDate = ({ initialDate: propInitialDate, finalDate: propFinalDate }) => {
    const theme = useTheme();
    const classes = useStyles();
    const [initialDate, setInitialDate] = useState(propInitialDate || new Date());
    const [finalDate, setFinalDate] = useState(propFinalDate || new Date());
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (propInitialDate) {
            setInitialDate(propInitialDate);
        }
    }, [propInitialDate]);

    useEffect(() => {
        if (propFinalDate) {
            setFinalDate(propFinalDate);
        }
    }, [propFinalDate]);

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId, initialDate, finalDate]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data)),
        datasets: [
            {
                // label: 'Dataset 1',
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.total
                }),
                // Suporte a gradiente quando ativado
                backgroundColor: theme.palette?.gradient 
                  ? createGradient(theme.palette.primary.main, theme.palette.secondary?.main)
                  : theme.palette.primary.main,
            },
        ],
    };

    const handleGetTicketsInformation = async () => {
        try {
            const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);
        } catch (error) {
            toast.error(i18n.t("dashboard.toasts.ticketInfoError"));
        }
    }

    return (
        <>
            <Typography className={classes.modernTitle}>
                {i18n.t("dashboard.users.totalAttendances")} ({ticketsData?.count || 0})
            </Typography>

            {!propInitialDate && (
                <Box className={classes.modernFilters}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={initialDate}
                            onChange={(newValue) => { setInitialDate(newValue) }}
                            label={i18n.t("dashboard.date.initialDate")}
                            renderInput={(params) => <TextField {...params} size="small" variant="outlined" style={{ width: 180 }} />}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                        <DatePicker
                            value={finalDate}
                            onChange={(newValue) => { setFinalDate(newValue) }}
                            label={i18n.t("dashboard.date.finalDate")}
                            renderInput={(params) => <TextField {...params} size="small" variant="outlined" style={{ width: 180 }} />}
                        />
                    </LocalizationProvider>
                    <Button 
                        className={classes.modernButton}
                        onClick={handleGetTicketsInformation} 
                        variant='contained'
                        color="primary"
                    >
                        Filtrar
                    </Button>
                </Box>
            )}
            <Box className={classes.chartContainer} style={{ height: '300px' }}>
                <Bar options={options} data={dataCharts} />
            </Box>
        </>
    );
}
